<template>
  <a-card class="mood-record" :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator flex-between">
      <div class="title-1">心情记录</div>
      <a-button
        type="primary"
        icon="download"
        :loading="exportXlsLoading"
        @click="handleExportXls('心情记录')"
      >
        导出
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <TableList
        :columns="columns"
        :tableData="dataSource"
        :loading="loading"
        :scroll="{}"
        :pagination="ipagination"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
        </span>
      </TableList>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mapGetters } from 'vuex'
import TableList from '@comp/chart/TableList.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'MoodRecordCom',
  mixins: [JeecgListMixin, mixinDevice],
  components: { TableList },
  data() {
    return {
      description: '心情记录页面',
      // 表头
      columns: [
        {
          title: '#',
          align: 'center',
          dataIndex: 'index',
        },
        {
          title: '评论者名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '评论者角色',
          align: 'center',
          dataIndex: 'title',
        },
        {
          title: '心情记录',
          align: 'center',
          dataIndex: 'ementScore',
          // 渲染函数：类似react中jsx的写法
          customRender: (_, record) => {
            return (
              <span>
                {record.ementScore == 1 ? '愉悦' : record.ementScore == 0 ? '正常' : '未知情绪'}
              </span>
            )
          },
        },
        {
          title: '详细原因',
          align: 'center',
          dataIndex: 'comment',
          customCell: () => {
            return {
              style: {
                maxWidth: '800px',
              },
            }
          },
        },
        {
          title: '原因分析',
          align: 'center',
          dataIndex: 'tags',
        },
        // {
        //   title: '情绪标签',
        //   align: 'center',
        //   dataIndex: '',
        // },
        {
          title: '评论时间',
          dataIndex: 'createTime',
          align: 'center',
        },
      ],
      url: {
        list: '/rector/moodRecordAndWarnRecord',
        exportXlsUrl: '/rector/exportMoodRecordAndWarnRecordXls',
        // delete: '/aigoes/schoolWarnRecord/delete',
        // deleteBatch: '/aigoes/schoolWarnRecord/deleteBatch',
        // importExcelUrl: 'aigoes/schoolWarnRecord/importExcel',
      },
      dictOptions: {},
      disableMixinCreated: true,
    }
  },
  created() {
    this.queryParam = {
      type: 0,
      dataType: 2,
      userIdentity: this.identityId,
    }
    this.loadData(1)
  },
  computed: {
    ...mapGetters(['identityId']),
  },
  methods: {},
}
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
.mood-record {
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
  ///deep/ .ant-card-body {
  //  padding: 15px 20px !important;
  //}
  /deep/ .ant-pagination {
    .ant-select {
      width: auto !important;
    }
  }
}
</style>
